import { PATH_NAME } from 'constants/Routes';
import customizeData from 'components/customize/data';
import { MODE } from 'modules/entity/constants';
import { createDictionary, getPathName } from 'utils/utils';
import { APPOINTMENT_PREVIEW_TYPE, GROUP_ID } from 'constants/Parameters';
import appointmentData from 'appointments/preview/data/appointmentData.json';
import interventionData from 'appointments/preview/data/interventionData.json';

/**
 * @param {import('./types').Entity} _
 * @param {import('./types').Entity} entity
 * @returns {import('./types').Entity}
 */
const formatCustomize = (_, entity) => {
  const isAudit = entity.templateMode === MODE.AUDIT;
  return {
    ...(isAudit ? customizeData.audit : {}),
    ...(!isAudit && {
      ...customizeData.intervention,
      ...(entity.templateMode === MODE.SALES && { checklists: customizeData.checklistsSales }),
      ...(entity.templateMode === MODE.PARTS && customizeData.parts),
    }),
    ...entity,
    mode: entity.templateMode,
    groupId: GROUP_ID ?? entity.dealer?.group?.id,
  };
};

/**
 * @param {import('./types').Entity} _
 * @param {import('./types').Entity} entity
 * @returns {import('./types').Entity}
 */
const formatDealerPreview = (_, entity) => ({
  ...interventionData,
  ...appointmentData,
  brand: entity.brand,
  contact: entity.contact,
  translations: entity.translations,
  dealer: { ...entity, translations: undefined, brand: undefined },
  appointmentTasks: appointmentData.appointmentTasks?.filter(({ task }) => task.type === APPOINTMENT_PREVIEW_TYPE),
});

/**
 * @param {import('./types').Entity} state
 * @param {import('./types').Entity} entity
 * @returns {import('./types').Entity}
 */
const formatDefault = (state, entity) => ({
  ...entity,
  ...(entity.intervention
    ? {
      ...entity.intervention,
      interventionId: entity.intervention.id,
      interventionStatus: entity.intervention.status,
      intervention: undefined,
      contact: entity.intervention.contact,
    }
    : {}),
  ...(entity.sections ?? {}),
  id: entity.id,
});

/**
 * @param {import('./types').Entity} _
 * @param {import('./types').Entity} entity
 * @returns {import('./types').Entity}
 */
const formatTest = (state, entity) => {
  if (window.location.pathname.includes('customize')) {
    return formatCustomize(state, entity);
  }
  return formatDefault(state, entity);
};

const FORMAT_ENTITY_BY_PAGE = createDictionary(
  {
    [PATH_NAME.DEALERS_KEY_DEPOSIT]: formatDealerPreview,
    [PATH_NAME.CUSTOMIZE]: formatCustomize,
    [PATH_NAME.TEST]: formatTest,
  },
  formatDefault
);

/**
 * @param {import('./types').Entity} state
 * @param {import('./types').Entity} entity
 * @returns {import('./types').Entity}
 */
export const formatEntity = (state, entity) => FORMAT_ENTITY_BY_PAGE[getPathName()](state, entity);
